import { StatusType } from '../ApplicationPage/types';

export type ExpertiseListType = {
  border?: boolean;
  status?: StatusType;
};

export const expertiseExpertScore: ExpertiseExpertScoreType = {
  textbook_title_accordance: '',
  concept_accordance: '',
  textbook_body_accordance: '',
  mistakes_are_missing: '',
  textbook_lang_accordance: '',
  textbook_img_accordance: '',
  criminal_is_missing: '',
  impolite_is_missing: '',
  suicide_is_missing: '',
  addiction_is_missing: '',
  asocial_is_missing: '',
  violence_is_missing: '',
  terrorism_is_missing: '',
  lgbt_is_missing: '',
  theoretical_fullness: '',
  terminology_accordance: '',
  fake_is_missing: '',
  scientific_news_is_present: '',
  russian_science_is_present: '',
  for_all_good: '',
  logic_and_structure: '',
  methodologic_motivation: '',
  methodologic_analitic: '',
  methodologic_practic: '',
  methodologic_critic: '',
  group_activity: '',
  text_img_diversity: '',
  age_accordance: '',
  program_accordance: '',
  example_accordance: '',
  no_tests_in_textbook: '',
  links_in_texetbook_is_present: '',
  web_and_paper_accordance: '',
  correct_web_os: '',
  correct_web_device: '',
  web_aliacies_is_present: '',
  web_page_numbers: '',
  web_interactive_is_present: '',
};

export const expertiseExpertAdaptiveScore: ExpertiseExpertAdaptiveScoreType = {
  brile_is_present: '',
  application_is_present: '',
  application_web_and_paper_accordance: '',
  application_flat_printed: '',
  application_tiflopleer: '',
  application_navigation_is_present: '',
  img_to_tiflo_is_present: '',
  relief_is_present: '',
};

export type ExpertiseExpertNoAdaptiveScoreType = {
  textbook_affiliation: string;
};

export const expertiseExpertNoAdaptiveScore: ExpertiseExpertNoAdaptiveScoreType = {
  textbook_affiliation: '',
};

export type ExpertiseExpertAdaptiveScoreType = {
  brile_is_present: string;
  relief_is_present: string;
  application_is_present: string;
  application_web_and_paper_accordance: string;
  application_flat_printed: string;
  application_tiflopleer: string;
  application_navigation_is_present: string;
  img_to_tiflo_is_present: string;
};

export type ExpertiseExpertScoreType = {
  textbook_title_accordance?: string;
  concept_accordance?: string;
  textbook_body_accordance?: string;
  mistakes_are_missing?: string;
  textbook_lang_accordance?: string;
  textbook_img_accordance?: string;
  criminal_is_missing?: string;
  impolite_is_missing?: string;
  suicide_is_missing?: string;
  addiction_is_missing?: string;
  asocial_is_missing?: string;
  violence_is_missing?: string;
  terrorism_is_missing?: string;
  lgbt_is_missing?: string;
  theoretical_fullness?: string;
  terminology_accordance?: string;
  fake_is_missing?: string;
  scientific_news_is_present?: string;
  russian_science_is_present?: string;
  for_all_good?: string;
  logic_and_structure?: string;
  methodologic_motivation?: string;
  methodologic_analitic?: string;
  methodologic_practic?: string;
  methodologic_critic?: string;
  group_activity?: string;
  text_img_diversity?: string;
  age_accordance?: string;
  program_accordance?: string;
  example_accordance?: string;
  no_tests_in_textbook?: string;
  links_in_texetbook_is_present?: string;
  web_and_paper_accordance?: string;
  correct_web_os?: string;
  correct_web_device?: string;
  web_aliacies_is_present?: string;
  web_page_numbers?: string;
  web_interactive_is_present?: string;
  brile_is_present?: string;
  relief_is_present?: string;
  application_is_present?: string;
  application_web_and_paper_accordance?: string;
  application_flat_printed?: string;
  application_tiflopleer?: string;
  application_navigation_is_present?: string;
  img_to_tiflo_is_present?: string;
};

export type ExpertiseExpertListsType = {
  textbook_affiliation?: string;
  textbook_affiliation_comment?: string;
  textbook_title_accordance?: string;
  textbook_title_accordance_comment?: string;
  concept_accordance?: string;
  concept_accordance_comment?: string;
  textbook_body_accordance?: string;
  textbook_body_accordance_comment?: string;
  border_accuracy?: string;
  border_accuracy_comment?: string;
  mistakes_are_missing?: string;
  mistakes_are_missing_comment?: string;
  textbook_lang_accordance?: string;
  textbook_lang_accordance_comment?: string;
  textbook_img_accordance?: string;
  textbook_img_accordance_comment?: string;
  criminal_is_missing?: string;
  criminal_is_missing_comment?: string;
  impolite_is_missing?: string;
  impolite_is_missing_comment?: string;
  suicide_is_missing?: string;
  suicide_is_missing_comment?: string;
  addiction_is_missing?: string;
  addiction_is_missing_comment?: string;
  asocial_is_missing?: string;
  asocial_is_missing_comment?: string;
  violence_is_missing?: string;
  violence_is_missing_comment?: string;
  terrorism_is_missing?: string;
  terrorism_is_missing_comment?: string;
  lgbt_is_missing?: string;
  lgbt_is_missing_comment?: string;
  theoretical_fullness?: string;
  theoretical_fullness_comment?: string;
  terminology_accordance?: string;
  terminology_accordance_comment?: string;
  fake_is_missing?: string;
  fake_is_missing_comment?: string;
  unvereified_theories_is_missing?: string;
  unvereified_theories_is_missing_comment?: string;
  scientific_news_is_present?: string;
  scientific_news_is_present_comment?: string;
  russian_science_is_present?: string;
  russian_science_is_present_comment?: string;
  for_all_good?: string;
  for_all_good_comment?: string;
  logic_and_structure?: string;
  logic_and_structure_comment?: string;
  methodologic_motivation?: string;
  methodologic_motivation_comment?: string;
  methodologic_analitic?: string;
  methodologic_analitic_comment?: string;
  methodologic_practic?: string;
  methodologic_practic_comment?: string;
  methodologic_critic?: string;
  methodologic_critic_comment?: string;
  group_activity?: string;
  group_activity_comment?: string;
  text_img_diversity?: string;
  text_img_diversity_comment?: string;
  age_accordance?: string;
  age_accordance_comment?: string;
  program_accordance?: string;
  program_accordance_comment?: string;
  adaptive_accordance?: string;
  adaptive_accordance_comment?: string;
  example_accordance?: string;
  example_accordance_comment?: string;
  no_tests_in_textbook?: string;
  no_tests_in_textbook_comment?: string;
  links_in_texetbook_is_present?: string;
  links_in_texetbook_is_present_comment?: string;
  web_and_paper_accordance?: string;
  web_and_paper_accordance_comment?: string;
  correct_web_os?: string;
  correct_web_oscomment?: string;
  correct_web_device?: string;
  correct_web_device_comment?: string;
  web_aliacies_is_present?: string;
  web_aliacies_is_present_comment?: string;
  web_page_numbers?: string;
  web_page_numbers_comment?: string;
  web_interactive_is_present?: string;
  web_interactive_is_present_comment?: string;
  brile_is_present?: string;
  brile_is_present_comment?: string;
  relief_is_present?: string;
  relief_is_present_comment?: string;
  application_is_present?: string;
  application_is_present_comment?: string;
  application_web_and_paper_accordance?: string;
  application_web_and_paper_accordance_comment?: string;
  application_flat_printed?: string;
  application_flat_printed_comment?: string;
  application_tiflopleer?: string;
  application_tiflopleer_comment?: string;
  application_navigation_is_present?: string;
  application_navigation_is_present_comment?: string;
  img_to_tiflo_is_present?: string;
  img_to_tiflo_is_present_comment?: string;
};

export type CollapsableItemsType = {
  textbook_affiliation?: boolean;
  textbook_title_accordance?: boolean;
  textbook_body_accordance?: boolean;

  concept_accordance?: boolean;
  border_accuracy?: boolean;
  mistakes_are_missing?: boolean;
  textbook_lang_accordance?: boolean;
  textbook_img_accordance?: boolean;
  criminal_is_missing?: boolean;
  impolite_is_missing?: boolean;
  suicide_is_missing?: boolean;
  addiction_is_missing?: boolean;
  asocial_is_missing?: boolean;
  violence_is_missing?: boolean;
  terrorism_is_missing?: boolean;
  lgbt_is_missing?: boolean;
  theoretical_fullness?: boolean;
  terminology_accordance?: boolean;
  fake_is_missing?: boolean;
  unvereified_theories_is_missing?: boolean;
  scientific_news_is_present?: boolean;
  russian_science_is_present?: boolean;
  for_all_good?: boolean;
  logic_and_structure?: boolean;
  methodologic_motivation?: boolean;
  methodologic_analitic?: boolean;
  methodologic_practic?: boolean;
  methodologic_critic?: boolean;
  group_activity?: boolean;
  text_img_diversity?: boolean;
  age_accordance?: boolean;
  program_accordance?: boolean;
  adaptive_accordance?: boolean;
  example_accordance?: boolean;
  no_tests_in_textbook?: boolean;
  links_in_texetbook_is_present?: boolean;
  web_and_paper_accordance?: boolean;
  correct_web_os?: boolean;
  correct_web_device?: boolean;
  web_aliacies_is_present?: boolean;
  web_page_numbers?: boolean;
  web_interactive_is_present?: boolean;
  brile_is_present?: boolean;
  relief_is_present?: boolean;
  application_is_present?: boolean;
  application_web_and_paper_accordance?: boolean;
  application_flat_printed?: boolean;
  application_tiflopleer?: boolean;
  application_navigation_is_present?: boolean;
  img_to_tiflo_is_present?: boolean;
};
